'use strict'

export default {
  getWallet(cb, errorCb, request = '') {
    axios.get(`/wallet${request}`)
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  },
  postTransfer(cb, errorCb, request = {}) {
    axios.post(`/wallet/transfer`, request)
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  },
  newTransfer(cb, errorCb, request = {}) {
    axios.post('slot-machine/deposit', request)
    .then(response => cb(response))
    .catch(err => {
      if (typeof errorCb === 'function') {
        errorCb(err)
      }
    })
  },
  createAviaFishWallet(cb, errorCb, request = {}) {
    axios.post('/wallet/login-aviafish', request)
    .then(response => cb(response))
    .catch(err => {
      if (typeof errorCb === 'function') {
        errorCb(err)
      }
    })
  },
  getAmbTransaction(cb, errorCb, request = {}) {
    axios.post('/wallet/amb/transactions')
    .then(response => cb(response))
    .catch(err => {
      if (typeof errorCb === 'function') {
        errorCb(err)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/admin/api/wallet.js